<template>
  <div class="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
    </div>

    <div>
      <h3>AI库离线翻译付费服务协议 </h3>
      <p class="pt8">发布日期：2025年07月10日</p> 
      <p class="pt8">生效日期：2025年07月10日</p>
      <div class="fw700 pt8">欢迎您使用AI库离线翻译付费服务，请您仔细阅读、理解并遵守如下协议。</div>

      <div class="section-title">一、服务内容说明</div>
      <p>1.购买后用户可享受离线翻译服务，包括但不限于：</p>
      <p>
        o离线翻译功能（支持10种语言包，分别为：中文、英语、德语、日语、韩语、印地语、泰语、西班牙语、法语、俄语。具体以APP内展示为准）
      </p>
      <p>
        o无广告体验、更高优先级的服务器响应等权益
      </p>

      <div class="section-title">二、服务免责条款</div>
      <p>
        1.翻译准确性说明：
      </p>
      <p>o翻译结果受环境噪音、拾音设备、语音清晰度等因素影响不保证100%准确率。</p>
      <p>o语言表达具有多样性，翻译结果可能存在非唯一性</p>
      <p>o偶发的个别语句不准确属正常现象，不构成退款理由</p>
      <p>2.离线翻译限制：</p>
      <p>o离线语言包需手动下载，仅限已下载语种使用</p>
      <p>o离线翻译功能可能无法获得与在线翻译相同的更新精度 </p>
      <div class="section-title">三、购买规则</div>
      <p>1.支付方式：通过官方应用商店或指定支付渠道完成</p>
      <p>2.虚拟商品属性：付费成功后不支持退换/转让</p>
      <p>3.有效期：离线翻译购买后即拥有永久使用权，权益跟随蓝牙设备，更换设备需重新购买服务。</p>
      <div class="section-title">四、账号责任</div>
      <p>1.禁止通过非官方渠道购买，因此导致的损失由用户承担</p>
      <p>2.账号共享行为可能导致服务终止且不退款</p>
      <p>3.用户违约时，我们可停止服务且不退款。</p>

      <div class="section-title">五、服务变更</div>
      <p>1.我们保留调整服务内容、价格及条款的权利，重大变更将提前通知</p>
      <p>2.因不可抗力导致服务中断时，将提供合理补偿方案</p>

      <div class="section-title">六、隐私条款</div>
      <p>1.翻译内容将按《隐私政策》进行加密处理</p>
      <p>2.用户需确保输入内容不违反法律法规</p>

      <div class="section-title">七、争议处理</div>
      <p>1.如有异议请于付费起7日内联系客服邮箱：service@xuanjiai.cn</p>
      <p>2.最终解释权归深圳市玄机人工智能科技有限公司所有。</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: "cn",
      closeImage: require("@/assets/close.png"),
      width: "100%",
      height: "100vh",
      url: "https://www.xuanjiai.cn/app/terms.html",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "cn";
    if (this.lang === "cn") {
      this.url = "https://www.xuanjiai.cn/app/terms.html";
    } else {
      this.url = "https://www.xuanjiai.cn/app/terms_en.html";
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/OffLinePage",
      });
    },
  },
};
</script>

<style scoped>
.app {
  height: 100vh;
  text-align: left;
  overflow: auto;
  padding: 0px 16px;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.user-agreement {
  height: calc(100vh - 44px);
  border: none;
  overflow: hidden;
}
iframe {
  overflow: hidden;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #0888FF;
    margin-top: 8px;
}
.pt8 {
  padding-top: 8px;
}
.fw700{
  font-weight: 700;
}
</style>